<template>
  <div class="p-4">
    <button @click="openNewSuppliersGroupDialog" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Supplier Group
    </button>
    <el-table
      :data="suppliers_groups.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name"
        sortable>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
        <template slot-scope="scope">
          <el-button @click="updateSuppliersGroup(scope.$index, scope.row)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deleteSuppliersGroup(scope.$index, scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <SuppliersGroupUpdateForm />
    <NewSuppliersGroupForm />
  </div>
</template>

<script>

import { flatMap } from 'lodash';
import NewSuppliersGroupForm from './_includes/NewSuppliersGroupForm.vue';
import SuppliersGroupUpdateForm from './_includes/SuppliersGroupUpdateForm.vue';

export default {
  name: 'SuppliersGroup',
  components: {
    SuppliersGroupUpdateForm,
    NewSuppliersGroupForm,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    suppliers_groups() {
      return flatMap(this.$store.state.InventoryModule.SuppliersGroup.suppliers_groups);
    },
  },
  methods: {
    openNewSuppliersGroupDialog() {
      this.$modal.show('new-suppliers-group-modal');
    },
    updateSuppliersGroup(index, suppliersGroup) {
      this.$modal.show('update-suppliers-group-modal');
      this.$store.commit('InventoryModule/SuppliersGroup/setProperty', { property: 'suppliers_group', payload: suppliersGroup });
    },
    deleteSuppliersGroup(index, groupId) {
      this.$confirm('Are you sure you want to delete this suppliers group?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/SuppliersGroup/deleteSuppliersGroup', { groupId });
          this.$notify.success({
            title: 'Success',
            message: 'Suppliers group has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
